import { useContext, useState } from 'react';
import { ActivityList } from "components/ActivityList";
import { MapView } from "providers/MapProvider"

import 'styles/HomePage.css';

import { MapContext } from "providers/MapProvider";
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';



const startOfTime = new Date(-1,11,32);
const endOfTime = new Date(9999,11,31);

const addDays = (date, days) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate
}

const getWeekdayName = (date) => date.toLocaleDateString('en-US', { weekday: 'long' });


// TODO: Take a close look at Lighthouse scores and improve


export default function HomePage(){
  // TODO: allow user to filter events by group

  const { visibleActivities } = useContext(MapContext);

  const [timeWindow, setTimeWindow] = useState({start: null, end: endOfTime});

  return (
  <div className="home-page">
    <div className="home-map">
      <div id="map_time_control">
        <TimeWindowControl {...{timeWindow, setTimeWindow}} />
      </div>
      <MapView id="home_map" options={{locationSelector: false, activityMarkers: true, geocoder: true, indicatedActivity: null, timeWindow}}/>
    </div>
    <div className="home-activity-pane">
      <div>Welcome to TagAlong. Get started by checking out tags near you on the map.</div>
      <div id="pane_time_control">
        <div>Happening</div>
        <TimeWindowControl {...{timeWindow, setTimeWindow}} />
      </div>
      <ActivityList activities={visibleActivities} scrollbar="mandatory" />
    </div>
  </div>)
}

function TimeWindowControl({timeWindow, setTimeWindow}) {

  // TODO: allow user finer control over time window

  const now = new Date();
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const options = [
    {text: 'Now', timeWindow: null},
    {text: 'Today', timeWindow: {start: null, end: addDays(startOfToday,1)} },
    {text: 'Tomorrow', timeWindow: {start: addDays(startOfToday,1), end: addDays(startOfToday,2)} },
    //{text: getWeekdayName(addDays(startOfToday,2)), timeWindow: {start: addDays(startOfToday,2), end: addDays(startOfToday,3)} },
    {text: 'Any time', timeWindow: {start: null, end: endOfTime}}
  ]

  const timeWindowsEqual = (tw1, tw2) =>
    (tw1 === tw2) ||
    (
      tw1?.start?.getTime() === tw2?.start?.getTime()
      &&
      tw1?.end?.getTime() === tw2?.end?.getTime()
    );
  
  return (    
    <div className="time-window-control">
      {
        options.map(option =>
          <button
            key = {option.text}
            className = {timeWindowsEqual(option.timeWindow, timeWindow) ? "selected" : ""}
            onClick = {() => {setTimeWindow(option.timeWindow)}}>
              {option.text}
          </button>
        )
      }
    </div>
  )
}